import React, { Component } from "react";
import { Link } from "react-router-dom";

class SubNavStickers extends Component {
  render() {
    return (
      <div className="subnav">
        <ul align="center">
          <li className="subnav-item">
            <Link to="/stickers/pwdo">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1540479507/rtds_work/Stickers/PWDO2018-Logo-Mockup.jpg"
                alt="client-app"
              />
            </Link>
          </li>
          <li className="subnav-item">
            <Link to="/stickers/omg">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1540401409/rtds_work/Logo/OMGLogoMockup.jpg"
                alt="client-app"
              />
            </Link>
          </li>
        </ul>
      </div>
    );
  }
}

export default SubNavStickers;



// WEBPACK FOOTER //
// ./src/components/pages/category/SubNavStickers.js